import { useState } from 'react';
import { getOrg } from '../../api/gsIntg';
import { ERROR_COPY } from '../../utils/constants';

// Shown when the widget URL carries no orgId (e.g. the Bloomreach preset's Widget URL
// was left without one). What we call an "org token" here is the same orgId the query
// param would otherwise supply — getOrg() is the source of truth for whether it's real.
const AuthScreen = ({ onAuthenticated }) => {
  const [token, setToken] = useState('');
  const [status, setStatus] = useState('idle'); // idle | checking | error
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (event) => {
    setToken(event.target.value);
    if (status === 'error') setStatus('idle');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmed = token.trim();
    if (!trimmed) {
      setStatus('error');
      setErrorMessage('Enter your org token to continue.');
      return;
    }

    setStatus('checking');
    try {
      const org = await getOrg(trimmed);
      if (!org) {
        setStatus('error');
        setErrorMessage(ERROR_COPY.invalidOrgToken);
        return;
      }
      onAuthenticated(trimmed);
    } catch {
      setStatus('error');
      setErrorMessage(ERROR_COPY.unreachableService);
    }
  };

  return (
    <div className="bloomreach-widget br-shell">
      <div className="br-auth" data-testid="bloomreach-widget-auth-screen">
        <form className="br-auth__card" onSubmit={handleSubmit}>
          <h2 className="br-auth__title">Gupshup WhatsApp for Bloomreach</h2>
          <p className="br-auth__subtitle">Enter your org token to continue.</p>

          <label className="br-auth__label" htmlFor="bloomreach-widget-auth-token">
            Org Token
          </label>
          <input
            id="bloomreach-widget-auth-token"
            className="br-auth__input"
            data-testid="bloomreach-widget-auth-input"
            type="text"
            autoComplete="off"
            autoFocus
            placeholder="Enter your org token"
            value={token}
            onChange={handleChange}
          />

          {status === 'error' && (
            <p className="br-auth__error" data-testid="bloomreach-widget-auth-error">
              {errorMessage}
            </p>
          )}

          <button
            type="submit"
            className="br-auth__submit"
            data-testid="bloomreach-widget-auth-submit"
            disabled={status === 'checking'}
          >
            {status === 'checking' ? 'Checking…' : 'Continue'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AuthScreen;
